module.exports = __webpack_public_path__ + "img/chapterstudio-logo.69c16b09.svg";